import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SearchFilter } from "../../components/SearchFilter";
import { getAds } from "../../api/supabase";
import { Ad, SupportedLanguages } from "../../types";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";

const CustomButtonRootMobile = styled(Button)(
  ({ theme }) => `
    background: linear-gradient(135deg, rgb(234, 91, 112), rgb(255, 142, 158));
    border-radius: 12px;
    width: 100%;
    max-width: 300px;
    height: 52px;
    margin-top: 40px;
    color: white;
    font-weight: 600;
    font-size: 24px;
    padding: 20px 40px;
    font-family: ${theme.typography.fontFamily};
    text-transform: none;
    box-shadow: 0 4px 12px rgba(234, 91, 112, 0.4);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background: linear-gradient(135deg, rgb(255, 100, 130), rgb(255, 160, 180));
      box-shadow: 0 6px 18px rgba(234, 91, 112, 0.5);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 3px 8px rgba(234, 91, 112, 0.3);
    }
  `,
);

export const Selectors = () => {
  const [ads, setAdds] = useState<Ad[]>([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedAge, setSelectedAge] = useState("");
  const [selectedActivity, setSelectedActivity] = useState("");
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage;
  const allCities = [...new Set(ads.map((ad) => ad.city).filter(Boolean))];
  const allAges = [
    ...new Set(
      ads
        .map((ad) => ad.age_tags)
        .flat()
        .filter(Boolean),
    ),
  ];
  const allActivities = [
    ...new Set(
      ads
        .map((ad) => ad.activity_tags)
        .flat()
        .filter(Boolean),
    ),
  ];
  const navigate = useNavigate();
  const onSearch = () => {
    navigate("/map", {
      state: {
        city: selectedCity,
        age: selectedAge,
        activity: selectedActivity,
      },
    });
  };

  useEffect(() => {
    const fetchAds = async () => {
      const ads = await getAds(currentLanguage as SupportedLanguages);
      setAdds(ads);
    };
    fetchAds().catch(console.error);
  }, [currentLanguage]);

  return (
    <div
      className="flex w-full justify-center flex-wrap gap-x-3 gap-y-3"
      id="selectors2"
    >
      <SearchFilter
        onSearch={onSearch}
        selectedAge={selectedAge}
        ages={allAges}
        setAge={setSelectedAge}
        selectedActivity={selectedActivity}
        activities={allActivities}
        setActivity={setSelectedActivity}
        selectedCity={selectedCity}
        cities={allCities}
        setCity={setSelectedCity}
      />
      <div className="lg:hidden">
        <CustomButtonRootMobile variant="contained" onClick={onSearch}>
          <span className="m-10">{t("selectors.find")}</span>

          <SearchIcon fontSize="large" />
        </CustomButtonRootMobile>
      </div>
    </div>
  );
};
